var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 14,
    fill: "#FF796D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24,10.54c3.72,0 6.75,2.79 6.75,6.21c0,3.43 -3.03,6.21 -6.75,6.21c-3.72,0 -6.75,-2.79 -6.75,-6.21c0,-3.43 3.03,-6.21 6.75,-6.21zm0,15.53c-5.59,0 -10.12,4.17 -10.12,9.32l0,2.07l20.24,0l0,-2.07c0,-5.15 -4.53,-9.32 -10.12,-9.32z",
    fill: "#F0EEE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.29e2c898ec9143090179613360296513.svg";
export { ForwardRef as ReactComponent };